
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    ORTBUNKER_ACTION,
    ALL_ORTBUNKER,
    ADD_ORTBUNKER,
    FETCH_ORTBUNKER,
    EDIT_ORTBUNKER,
    DELETE_ORTBUNKER,
    FETCH_ORTBUNKERCHART,
    FETCH_ORTBUNKERSHOTCHART,
} from 'Actions/types';

import { NotificationManager } from 'react-notifications';
/**
 * On Range Bunker Test Actions
 */

    export const allORTBunkerTest = () =>{    
        
        return (dispatch) => { 
            dispatch({ type: ORTBUNKER_ACTION });
            return axios.get(AppConfig.apiurl+'/api/getonrbunker', { headers: AuthHeader.header })         
            .then(response => {             
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTBUNKER, payload: alldata });
            });
        }        

    }

    export const studentORTBunkerTest = (id, start, end) =>{
    
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end
        }

        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/studentonrbunker', payload,{ headers: AuthHeader.header })         
            .then(response => { 
                const alldata=response.data.data;
                dispatch({ type: ALL_ORTBUNKER, payload: alldata }); 
            });
        
        }
    }

    export const addORTBunkerTest = (data, sepmore) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student_1":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
        }

        for (let i = 0; i<sepmore; i++) {        
            
           
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
            
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
           
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }        

        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/addonrbunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTBunkerTest(stdid, start, end)(dispatch);
                    var area='';
                    var contact='';
                    fetchORTBunkerReport(stdid, start, end, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_ORTBUNKER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const fetchORTBunkerTest = (id, date) =>{
    
        var payload={
            "id":id,
            "date":date
        }
        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/getonrbunkerdetails', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){              
                    dispatch({ type: FETCH_ORTBUNKER, payload: resdata.data});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const editORTBunkerTest = (data, sepmore, oldate) =>{
        var stdid=data.target.student.value;
        var payload={
            "totval":1,
            "student":data.target.student.value,
            "sgdate":data.target.seldate.value,
            "shtot_1":sepmore,
            "olddate":oldate,
        }

        for (let i = 0; i<sepmore; i++) {        
            
            
            var right='right_'+i;            
            var rightval=data.target[right].value;
            var left='left_'+i;            
            var leftval=data.target[left].value;
            var short='short_'+i;            
            var shortval=data.target[short].value;
            var long='long_'+i;            
            var longval=data.target[long].value;
            var contact='contact_'+i;            
            var contactval=data.target[contact].value;
            var area='area_'+i;            
            var areaval=data.target[area].value;
            var process='process_'+i;            
            var processval=data.target[process].value;
            var septravel='missedgreen_'+i;            
            var setrvalval=data.target[septravel].value;           
            
            var adval=i+1;
         
            var rightadd='right_1_'+adval;  
            var leftadd='left_1_'+adval;  
            var shortadd='short_1_'+adval;  
            var longadd='long_1_'+adval;  
            var contadd='contact_1_'+adval;  
            var areaadd='area_1_'+adval;      
            var septraveladd='outside_1_'+adval; 
            var processadd='process_1_'+adval;
            
            
            payload[rightadd]=rightval;
            payload[leftadd]=leftval;
            payload[shortadd]=shortval;
            payload[longadd]=longval;
            payload[contadd]=contactval;
            payload[areaadd]=areaval;           
            payload[septraveladd]=setrvalval;
            payload[processadd]=processval;            
    
        }

        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/editonrbunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTBunkerTest(stdid, start, end)(dispatch);
                    var area='';
                    var contact='';
                    fetchORTBunkerReport(stdid, start, end, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: EDIT_ORTBUNKER});                    
                }
                return Promise.resolve(resdata);
                
            });
        
        }
    }

    export const deleteORTBunkerTest = (id, date) =>{
        
        var payload={
            "id":id,
            "date":date
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/deleteonrbunker', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data;
                if(resdata.status===1){
                    var start='';
                    var end='';
                    studentORTBunkerTest(id, start, end)(dispatch);
                    var area='';
                    var contact='';
                    fetchORTBunkerReport(id, start, end, area, contact)(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: DELETE_ORTBUNKER});                    
                }                
                
            });
        
        }
    }

    export const fetchORTBunkerReport = (id, start, end, area, contact) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "area":area,         
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangebunkerreport', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTBUNKERCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

    export const fetchORTBunkerShotChart = (id, start, end, area, contact, val) =>{
        
        var payload={
            "id":id,
            "startdate":start,
            "enddate":end,
            "contact":contact,
            "area":area,
            "section":val            
        }
        
        return (dispatch) => { 
            dispatch({ type:ORTBUNKER_ACTION, });
            return axios.post(AppConfig.apiurl+'/api/onrangebunkershotchart', payload,{ headers: AuthHeader.header })         
            .then(response => {             
                var resdata=response.data.data;
                dispatch({ type: FETCH_ORTBUNKERSHOTCHART, payload: resdata}); 
                
                return Promise.resolve(resdata);               
                
            });
        
        }
    }

